import { render, staticRenderFns } from "./ClinicExpenses.vue?vue&type=template&id=40775c8e"
import script from "./ClinicExpenses.vue?vue&type=script&lang=js"
export * from "./ClinicExpenses.vue?vue&type=script&lang=js"
import style0 from "./ClinicExpenses.vue?vue&type=style&index=0&id=40775c8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports